import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { IconVirtualBackgroundFilled } from 'jitsi/base/icons/svg';
import { VideoBackgroundButton, _mapStateToProps, } from 'jitsi/virtual-background/components/VideoBackgroundButton';
class VideoBackgroundCircleButton extends VideoBackgroundButton {
    constructor() {
        super(...arguments);
        this.icon = IconVirtualBackgroundFilled;
    }
}
export default translate(connect(_mapStateToProps)(VideoBackgroundCircleButton));
